import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { BoobleModalService } from 'booble-modal';
import { AuthenticationService } from 'src/app/shared/services';

@Component({
  selector: 'app-create-order-confirm',
  templateUrl: './create-order-confirm.component.html',
  styleUrls: ['./create-order-confirm.component.scss'],
})
export class CreateOrderConfirmComponent implements OnInit {
  boobleModalData: number;
  isMobile = false;

  get companyId() {
    return +this.accountService.getCompanyId();
  }

  get individualId() {
    return +this.accountService.getIndividualId();
  }

  constructor(
    private modalService: BoobleModalService,
    private matIconRegistry: MatIconRegistry,
    private readonly accountService: AuthenticationService,
    private domSanitzer: DomSanitizer
  ) {
    this.matIconRegistry.addSvgIcon(
      'success',
      this.domSanitzer.bypassSecurityTrustResourceUrl('assets/icons/sucess.svg')
    );
    this.isMobile = window.innerWidth <= 820 ? true : false;
  }
  ngOnInit(): void {}

  closeModal() {
    this.modalService.dismiss(null);
  }
}
